import fileUtils from '@/utils/fileUtils'

/**
 * 防盗链图片指令
 * 使用方法：<img v-secure-image="filePath" />
 * 或者：<img v-secure-image="{path: filePath, fallback: fallbackUrl}" />
 */
const secureImageDirective = {
  name: 'secure-image',
  
  bind(el, binding, vnode) {
    // 初始化元素属性
    el._secureImageConfig = {
      loading: false,
      originalSrc: '',
      fallbackSrc: '',
      retryCount: 0,
      maxRetries: 2
    }
  },

  async update(el, binding, vnode) {
    const config = el._secureImageConfig
    
    // 避免重复处理相同的路径
    if (config.loading) {
      return
    }

    let filePath = ''
    let fallbackSrc = ''

    // 解析绑定值
    if (typeof binding.value === 'string') {
      filePath = binding.value
    } else if (typeof binding.value === 'object' && binding.value !== null) {
      filePath = binding.value.path || binding.value.filePath || ''
      fallbackSrc = binding.value.fallback || ''
    }

    // 如果路径为空或者与上次相同，不处理
    if (!filePath || filePath === config.originalSrc) {
      return
    }

    config.originalSrc = filePath
    config.fallbackSrc = fallbackSrc
    config.loading = true

    try {
      // 如果已经是完整的HTTP URL，直接设置
      if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
        el.src = filePath
        config.loading = false
        return
      }

      // 获取防盗链URL
      const secureUrl = await fileUtils.getSecureUrl(filePath)
      
      if (secureUrl) {
        el.src = secureUrl
        
        // 添加错误处理
        const errorHandler = () => {
          config.retryCount++
          
          if (config.retryCount <= config.maxRetries) {
            // 重试获取防盗链URL
            setTimeout(async () => {
              try {
                const retryUrl = await fileUtils.getSecureUrl(filePath, false) // 不使用缓存
                el.src = retryUrl
              } catch (error) {
                handleFallback()
              }
            }, 1000 * config.retryCount)
          } else {
            handleFallback()
          }
        }

        const handleFallback = () => {
          // 使用回退URL
          if (config.fallbackSrc) {
            el.src = config.fallbackSrc
          } else {
            el.src = fileUtils.getFallbackUrl(filePath)
          }
          el.removeEventListener('error', errorHandler)
        }

        // 移除之前的错误监听器
        if (el._errorHandler) {
          el.removeEventListener('error', el._errorHandler)
        }
        
        // 添加新的错误监听器
        el._errorHandler = errorHandler
        el.addEventListener('error', errorHandler)
      } else {
        // 如果获取防盗链URL失败，使用回退URL
        el.src = config.fallbackSrc || fileUtils.getFallbackUrl(filePath)
      }
    } catch (error) {
      console.error('获取防盗链URL失败:', error)
      // 使用回退URL
      el.src = config.fallbackSrc || fileUtils.getFallbackUrl(filePath)
    } finally {
      config.loading = false
    }
  },

  unbind(el) {
    // 清理事件监听器
    if (el._errorHandler) {
      el.removeEventListener('error', el._errorHandler)
      delete el._errorHandler
    }
    
    // 清理配置
    delete el._secureImageConfig
  }
}

/**
 * 安装指令的函数
 * @param {Vue} Vue Vue构造函数
 */
export function install(Vue) {
  Vue.directive('secure-image', secureImageDirective)
}

export default secureImageDirective


// WEBPACK FOOTER //
// ./src/directives/secureImage.js